// Tampilan jam menurut zona waktu cabang (WIB/WITA/WIT), bukan jam komputer yang membuka web.
//
// waktuCabang(t) mengembalikan Date yang sudah digeser sehingga fungsi format lokal (dayjs,
// date-fns format, toLocaleString) menampilkan jam dinding cabang. Indonesia tanpa jam musim panas,
// jadi selisih zona selalu tetap.

const OFFSET_MENIT = { WIB: 7 * 60, WITA: 8 * 60, WIT: 9 * 60 };

// Zona cabang pengguna yang login (diisi AuthSlice dari data login / /me). Superadmin: WIB.
let zonaPengguna = 'WIB';

export const setZonaPengguna = (zona) => {
  zonaPengguna = OFFSET_MENIT[zona] ? zona : 'WIB';
};

export const getZonaPengguna = () => zonaPengguna;

/**
 * @param {string|number|Date} t waktu (mis. createdAt dari server)
 * @param {string} [zona] zona cabang data (mis. transaksi.User.Cabang.zona_waktu); default zona pengguna
 */
export const waktuCabang = (t, zona) => {
  const d = t instanceof Date ? t : new Date(t ?? Date.now());
  if (Number.isNaN(d.getTime())) return d;
  const z = OFFSET_MENIT[zona] ? zona : zonaPengguna;
  const offsetBrowser = -d.getTimezoneOffset();
  return new Date(d.getTime() + (OFFSET_MENIT[z] - offsetBrowser) * 60000);
};

// Label zona untuk ditampilkan di samping jam.
export const labelZona = (zona) => (OFFSET_MENIT[zona] ? zona : zonaPengguna);
